import { render, staticRenderFns } from "./AffirmFooter.vue?vue&type=template&id=361c299d&"
import script from "./AffirmFooter.vue?vue&type=script&lang=js&"
export * from "./AffirmFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports